import React from 'react';
import PageView from '../components/sections/PageView';

const CommunityPage = () => <PageView slug="community" />;

export default CommunityPage;
